import { render, staticRenderFns } from "./ResultList.vue?vue&type=template&id=f2311e68&"
import script from "./ResultList.js?vue&type=script&lang=js&"
export * from "./ResultList.js?vue&type=script&lang=js&"
import style0 from "./ResultList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports